"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.KeyCode = exports.ifNotEmpty = exports.renderStyleCssGlobally = exports.renderStyleGlobally = exports.safariForceRepaint = exports.shadowDOMPolyfillContainingBlockFixChild = exports.shadowDOMPolyfillContainingBlockFix = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t/**\n\t* This is a hack for safari only to force reflow on a fixed positioned element\n\t* inside a shadow dom. Should be removed when safari fix this issue.\n\t*/\n\t@keyframes repaint {\n\t\t0% {\n\t\t\tbox-shadow: 1px 1px 1px transparent;\n\t\t}\n\t\t100% {\n\t\t\tbox-shadow: 0px 0px 0px transparent;\n\t\t}\n\t}\n\t@media not all and (min-resolution: 0.001dpcm) {\n\t\t@media {\n\t\t\t:host {\n\t\t\t\tanimation-name: repaint;\n\t\t\t\tanimation-duration: 1ms;\n\t\t\t\tanimation-iteration-count: infinite;\n\t\t\t}\n\t\t}\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t/**\n\t* This is because IE does not honor the containing block rules regarding\n\t* position: fixed with a parent with filter or transform\n\t* With this only on IE it will fallback to position absolute and will\n\t* need a parent with position: relative\n\t* TODO: Remove when IE 11 is gone\n\t*/\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\t:host {\n\t\t\tposition: absolute !important;\n\t\t}\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\t/**\n\t* This is because Firefox doesn't support shadowDOM\n\t* and the position fixed is the viewport and not the shadow root.\n\t* With this hack we make the browser to use the\n\t* host element as containing block\n\t*/\n\t\t-moz-filter: blur(0px);\n\t\t/**\n\t* This is because Safari doesn't work correctly with shadowDOM\n\t* and the position fixed is the viewport and not the shadow root.\n\t* With this hack we make the browser to use the\n\t* host element as containing block\n\t*/\n\t\ttransform: scaleX(1);\n\t}\n\n\t/**\n\t* This is because IE does not honor the containing block rules regarding\n\t* position: fixed with a parent with filter or transform\n\t* With this only on IE it will fallback to position absolute and will\n\t* need a parent with position: relative\n\t*/\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\t:host {\n\t\t\tposition: relative !important;\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var shadowDOMPolyfillContainingBlockFix = (0, _element.css)(_templateObject());
exports.shadowDOMPolyfillContainingBlockFix = shadowDOMPolyfillContainingBlockFix;
var shadowDOMPolyfillContainingBlockFixChild = (0, _element.css)(_templateObject2());
exports.shadowDOMPolyfillContainingBlockFixChild = shadowDOMPolyfillContainingBlockFixChild;
var safariForceRepaint = (0, _element.css)(_templateObject3());
exports.safariForceRepaint = safariForceRepaint;

var renderStyleGlobally = function renderStyleGlobally(style, name) {
  if (!document || !document.head) {
    return;
  }

  var prev = document.head.querySelector("style[data-component=\"".concat(name, "\"]"));

  if (prev) {
    return;
  }

  var container = document.createElement('div');
  (0, _element.render)(style, container);

  if (container === null || container === void 0 ? void 0 : container.firstElementChild) {
    container.firstElementChild.setAttribute('data-component', name);
    var append = document.head.append || document.head.appendChild;
    append.call(document.head, container.firstElementChild);
  }
};

exports.renderStyleGlobally = renderStyleGlobally;

var renderStyleCssGlobally = function renderStyleCssGlobally(style, name) {
  var supportsAdoptingStyleSheets = document.adoptedStyleSheets && 'replace' in CSSStyleSheet.prototype;

  if (!document || !document.head) {
    return;
  }

  if (supportsAdoptingStyleSheets) {
    var _context, _context2;

    var styleSheet = style.styleSheet;
    document.adoptedStyleSheets = (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)((0, _filter.default)(_context2 = document.adoptedStyleSheets).call(_context2, function (s) {
      return s !== styleSheet;
    })), [styleSheet]);
  } else {
    var prev = document.head.querySelector("style[data-component=\"".concat(name, "\"]"));

    if (prev) {
      return;
    }

    var container = document.createElement('style');
    container.innerHTML = style.cssText;
    container.setAttribute('data-component', name);
    var append = document.head.append || document.head.appendChild;
    append.call(document.head, container);
  }
};

exports.renderStyleCssGlobally = renderStyleCssGlobally;
var ifNotEmpty = (0, _element.directive)(function (value) {
  return function (part) {
    if ((value === '' || value === null || value === undefined) && part instanceof _element.AttributePart) {
      if (value !== part.value) {
        var name = part.committer.name;
        part.committer.element.removeAttribute(name);
      }
    } else {
      part.setValue(value);
    }
  };
});
exports.ifNotEmpty = ifNotEmpty;
var KeyCode;
exports.KeyCode = KeyCode;

(function (KeyCode) {
  KeyCode["Space"] = "Space";
  KeyCode["Tab"] = "Tab";
  KeyCode["Enter"] = "Enter";
  KeyCode["ArrowUp"] = "ArrowUp";
  KeyCode["ArrowDown"] = "ArrowDown";
  KeyCode["ArrowLeft"] = "ArrowLeft";
  KeyCode["ArrowRight"] = "ArrowRight";
  KeyCode["Home"] = "Home";
  KeyCode["End"] = "End";
})(KeyCode || (exports.KeyCode = KeyCode = {}));
